import React, { RefObject, forwardRef, useRef, useImperativeHandle, useEffect } from 'react'
import { useSafeState, useMount, useUpdate, useMemoizedFn, useUnmount } from 'ahooks'
import { useHistory, useLocation } from 'react-router-dom'
import { Image, List } from 'antd-mobile'

import { BackupTitle, useWindowSize } from 'pages/utils/utils'
import { sendBackToApp, requestTokenFromApp } from 'model/msg/msg'


// -----------------------------------------------------------------------
const AboutPage = forwardRef((props = {}, ref) => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const history = useHistory()
    const {width, height} = useWindowSize()

    let tmpVersion = "V1.0.4"

    const version = searchParams.get("version")
    if (version) {
        if (version !== "") {
            tmpVersion = version
        }
    }

    const backOnClickHd = () => {
        sendBackToApp("/profile/about")
    }

    const subPageOnClickHd = (key) => {
        if (key === "privacy") {
            history.push("/profile/privacyAgreement")
        }else if (key === "agreement") {
            history.push("/profile/userAgreement")
        }else if (key === "company") {
            history.push("/profile/company")
        }
    }

    return (
        <>
            <BackupTitle backOnClickHd={backOnClickHd} title="关于我们" noShare={true}/>
            <div className="row_space_big"/>
            <div className='row_center'>
                <Image src={process.env.PUBLIC_URL + "/images/logo.png"} width={width/3} height={width/3}/>
            </div>
            <div className="row_space_small"/>
            <div className='row_center'>
                <span style={{fontSize: "20px", fontWeight: 500}}>版本号：{tmpVersion}</span>
            </div>
            <div className="row_space_big"/>

            <List >
                <List.Item onClick={() => subPageOnClickHd("privacy")}>隐私政策</List.Item>
                <List.Item onClick={() => subPageOnClickHd("agreement")}>用户协议</List.Item>
                <List.Item extra="http://www.fortunebio.com">公司官网</List.Item>
                <List.Item onClick={() => subPageOnClickHd("company")}>公司介绍</List.Item>
            </List>
        </>
    )
})

const CompanyPage = forwardRef((props = {}, ref) => {
    const history = useHistory()

    const backOnClickHd = () => {
        history.goBack()
        sendBackToApp("/profile/company")
    }

    return (
        <>
            <BackupTitle backOnClickHd={backOnClickHd} noShare={true}/>
            <div className='row_center'>
                <h2>公司简介</h2>
            </div>
            <div className='textP'>
            郑州方欣生物科技有限责任公司成立于2003年10月，注册资本2000万元，是一家由留美博士牵头创立、专注于体外诊断试剂研发生产和销售的高新技术企业。
            </div>

            <div className='textP'>
            公司住所位于郑州航空港区郑州恒丰科创中心12号楼，建筑面积约5300平米，建设内容包括1500平米办公室、800平米研发实验室、2000平米净化车间及配套的质检室、冷库、常温库等。公司组织机构健全，管理规范，现有职工63人，大专及以上人员占比89%，各类专业技术人员占比56%，建立了ISO9001质量管理体系ISO13485医疗器械质量管理体系，并持续有效运行。
            </div>

            <div className='textP'>
            公司设施完备、设备齐全，拥有4条全自动金标产品生产线，可实现产能10万人份/天。生产范围为Ⅱ类6840体外诊断试剂、Ⅲ类 6840临床检验分析仪器、体外诊断试剂，围绕居家健康监测、解决现有市场产品痛点的目标，开发适用于居家大健康诊断的系列产品。现有产品注册证31个，其中三类3个，二类28个。产品类型包括优生优育检测产品，如早孕、排卵检测等；传染病检测产品，如艾滋病、乙肝、丙肝、梅毒、幽门螺杆菌等；肿瘤相关疾病检测产品，如大便隐血检测、肝癌检测等；衰老疾病检测产品，如阿尔兹海默症超早期检测、糖尿病早期检测、肾功能检测等；心脑血管疾病检测产品，如心梗、脑梗的早期检测等。
            </div>

            <div className='textP'>
            除主营业务之外，方欣生物还兼营代理产品业务，致力于为医疗机构和终端用户提供优质的产品和服务，目前已在国内外的线上、线下渠道建立了营销网络。其中，针对国内市场，和上百家二甲、三家医院达成紧密合作。针对国外市场，已经具备英国、墨西哥、巴西、俄罗斯、蒙古、哈萨克斯坦、韩国、德国、泰国、沙特等十几个国家的营销网络。
            </div>

            <div className='textP'>
            方欣生物秉承创新务实、超越自我、追求卓越的发展理念，不断提高企业管理水平和科技创新能力，努力打造具有一定影响力的IVD品牌企业，近年来相继获得国家高新技术企业、国家科技型中小企业、河南省专精特新中小企业、创新型中小企业等荣誉。公司坚持“价值即一切”的理念，为员工创造实现价值的平台、为客户提供有价值的产品和服务、为社会贡献价值。
            </div>

            <div className="row_space_small"/>
        </>
    )
})

const PrivacyAgreementPage = forwardRef((props = {}, ref) => {
    const history = useHistory()

    const backOnClickHd = () => {
        history.goBack()
        sendBackToApp("/profile/privacyAgreement")
    }

    return (
        <>
            <BackupTitle backOnClickHd={backOnClickHd} noShare={true}/>
            <div className='row_center'>
                <h2>健康前哨APP隐私政策</h2>
            </div>
            <div className='textP'>
            本隐私保护政策适用于郑州方欣生物科技有限责任公司（以下统称“我们”）的健康前哨APP。本隐私政策旨在帮助您了解我们如何收集、利用、存储和保护您的个人信息，同时我们也将告知您享有何种权利。
            </div>
            <div className='textP'>请您仔细阅读并充分理解本隐私政策协议</div>
            <div className='textP'>最近更新日期：2024年5月10日</div>
            <div className='textP'>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</div>

            <div className='textP'><div className='black'>电子邮件：fortunebio@126.com</div></div>
            <div className='textP'><div className='black'>电话：0371-55018786</div></div>
            <div className='textP'><div className='black'>注册地址：郑州航空港区新港七路与梅河东路交叉口郑州恒丰科创中心12号楼</div></div>
            <div className='textP'><div className='black'>办公地址：郑州航空港区新港七路与梅河东路交叉口郑州恒丰科创中心12号楼</div></div>

            <div className='textP'>目录</div>
            <div className='textP'>引言</div>
            <div className='textP'>一、我们如何收集您的个人信息</div>
            <div className='textP'>二、我们如何使用您的个人信息</div>
            <div className='textP'>三、我们如何存储和保护您的个人信息</div>
            <div className='textP'>四、您的权利</div>
            <div className='textP'>五、我们如何处理未成年人的个人信息</div>
            <div className='textP'>六、本隐私政策如何更新</div>
            <div className='textP'>七、如何联系我们</div>
            <div className='textP'>八、关键词定义</div>
            <div className='textP'>九、收集个人信息清单</div>
            <div className='textP'>十、第三方SDK列表</div>

            <div className='textP'><div className='black'>引言</div></div>
            <div className='textP'>我们非常重视用户的隐私和个人信息保护。您在使用我们的产品和/或服务时，我们可能会收集和使用您的信息。我们希望通过《健康前哨APP隐私保护政策》（“本隐私政策”）向您说明我们的业务情形和对应需要收集您个人信息的类型，以及我们为您提供访问、更新、删除这些信息的途径和保护措施，还有当我们共享、转让、公开披露您个人信息时需要遵守的规则。本隐私政策与您所使用的健康前哨APP服务以及该服务所包括的各种业务功能（以下统称“我们的产品和/或服务”）息息相关，希望您在使用我们的产品和/或服务前仔细阅读并确认您已经充分理解本隐私政策所记载的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们用简明扼要的表述，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品和/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、存储和保护您的相关信息。</div>
            <div className='textP'>需要特别说明的是，本隐私政策仅适用于本隐私政策定义的产品和/或服务。当您使用第三方机构直接向您提供的产品或服务并向其提供您的个人信息时，我们建议您在使用之前仔细查看他们的隐私政策，了解他们如何处理您的信息，以便审慎决策。</div>


            <div className='textP'><div className='black'>一、我们如何收集您的个人信息</div></div>
            <div className='textP'>我们会通过如下三种渠道获取您的个人信息：1、您直接提供的信息：我们可能收集并存储您在使用健康前哨APP服务时向我们提供的信息，包括您在我们页面中在线填写信息时、申请产品和/或服务时、解决争议或就健康前哨APP服务与我们联系时所提供的信息，以及您在使用我们服务过程中产生的关于您的交易和活动的信息。2、我们主动收集的信息：在您使用健康前哨APP及相关服务过程中，我们会收集您的硬件产品、计算机、手机及其他访问设备发送给我们的信息。3、我们从其他来源取得的信息：在取得您同意的前提下，我们还可能从关联公司及合作伙伴及依法成立并合法留存您的相关信息的第三方机构获取您的相关信息。</div>
            <div className='textP'>（一）各项服务</div>
            <div className='textP'>1、注册、登录、认证</div>
            <div className='textP'>您需要登录健康前哨APP，在此过程中，为对您的账号进行验证以实现登录的目的，我们将收集、存储您的手机号码用于账号登录。收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，若您不提供上述信息，则您将无法正常登录健康前哨APP。</div>
            <div className='textP'>您可自行选择补充提供出生日期、身高、体重、性别等信息。若您不提供上述信息，不影响您使用健康前哨APP服务。</div>
            <div className='textP'>在您使用身份认证的功能或相关服务所需时，根据相关法律法规，您可能需要提供您的真实身份信息（真实姓名、身份证号码等）以完成实名验证。部分信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得涉及个人敏感信息的相关服务，但不影响其他功能与服务的正常使用。</div>
            <div className='textP'>2、设备连接</div>
            <div className='textP'>为了您能够连接您使用的我们的产品，健康前哨APP会向您申请下列与个人信息相关的系统权限：拨打电话、照片文件读取权限、拍照权限。如果您不授权，将会导致我们无法提供健康监测APP的相关功能，但不影响其他功能与服务的正常使用。我们承诺将严格遵守数据保护法规，确保您的个人信息安全。这些权限的使用都是为了增强您的应用体验，并且我们会确保这些数据仅用于提升服务质量和用户体验。您可以随时在健康前哨APP的设置中管理这些权限，包括关闭或修改权限设置。</div>
            <div className='textP'>3、共享数据</div>
            <div className='textP'>为了方便您向例如亲友等共享自己的检测结果，我们会收集和存储您的关注、关注您的人的信息，收集这些信息是用于为您更好地进行数据共享。若您不提供上述信息，则您将无法使用该业务功能，但不影响其他功能与服务的正常使用。</div>
            <div className='textP'>4、生成报告</div>
            <div className='textP'>您选择使用该项业务功能时，您需要向我们提供或允许我们收集的必要信息包括：手机号、产品信息（型号，Mac地址等）。我们会将上述信息用于为您提供准确的压力报告。如果您不提供上述信息，则您无法使用该项业务功能，但不影响其他功能与服务的正常使用。在您使用该业务功能时，健康前哨APP会向您申请授权下列系统权限：网络权限，文件读写权限。我们会基于这两项权限，为您发送健康前哨APP生成的报告。如果您不授权，将会导致我们无法提供该业务功能，但不影响其他功能与服务的正常使用。我们承诺将严格遵守数据保护法规，确保您的个人信息安全。这些权限的使用都是为了增强您的应用体验，并且我们会确保这些数据仅用于提升服务质量和用户体验。您可以随时在健康前哨APP的设置中管理这些权限，包括关闭或修改权限设置。</div>
            <div className='textP'>（二）安全保障</div>
            <div className='textP'>为保障您使用我们的产品与服务时系统的稳定性和安全性，防止您的信息被非法获取，更准确地预防欺诈和保护账号安全，我们需要收集您的设备信息（设备型号、设备Mac地址、Wifi使用地址、设备识别码、操作系统及软件版本、设备状态、网络状况）、日志信息、IP地址、位置信息来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息用于对健康管理系统问题进行分析、统计流量并排查可能存在的风险，在您选择向我们发送异常信息时予以排查。如果您不提供上述信息，我们则无法在您使用服务过程中对您的服务及账号安全进行保护，但不影响其他功能与服务的正常使用。</div>
            <div className='textP'>（三）第三方服务</div>
            <div className='textP'>通过第三方主体或使用第三方服务：我们可能会在您的授权同意范围内从第三方（我们的合作方）处收集并使用您的个人信息。我们保证严格依照与第三方签订的合同以及相关法律规定处理您的个人信息，同时请您详细阅读该第三方的隐私政策及用户协议。如您拒绝第三方在提供服务时收集、使用或者传递您的个人信息，将可能导致您无法使用相应的服务。</div>
            
            <div className='textP'><div className='black'>二、我们如何使用您的个人信息</div></div>
            <div className='textP'>1、为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账号和资金安全，我们会在以下情形中使用您的信息：</div>
            <div className='textP'>（1）用来实现上述业务功能；</div>
            <div className='textP'>（2）保障产品与服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途；</div>
            <div className='textP'>（3）处理您对健康管理产品和/或服务的申请或反馈请求；</div>
            <div className='textP'>（4）评估、改善我们的业务功能与服务效果，维护和改进上述业务功能，开发新的业务功能；我们可能会收集的您的操作/使用记录（包括浏览、搜索、点击）、您主动提供的信息（评价、反馈），日志信息，IP地址，位置信息（包括您授权的GPS定位以及WLAN接入点、蓝牙和基站等传感器信息），设备信息（包括设备型号、操作系统版本、设备设置、设备环境、MAC地址及IMEIIMSI、IDFA、OAID等设备标识符、移动应用列表、电信运营商等软硬件特征，我们将会对数据进行分析、研究和开发与我们产品或服务的使用相关的统计信息；</div>
            <div className='textP'>（5）在您使用本App产品及/或服务时，您可能需要向本App提供手机号码、性别、身高、体重、生日、检测记录、样品信息、操作记录、照片等与您使用本App产品及/或服务相关的信息，以便创建账户信息和受检者信息，并帮助您完成相关检测记录和管理。我们通过技术手段对数据进行去标识化处理后，去标识化处理的信息将无法识别主体。</div>
            <div className='textP'>2、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏展示，以保护您的信息安全。</div>
            <div className='textP'>3、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。如果您选择使用本隐私政策中尚未列明的其他产品和/或服务时，在我们收集您的个人信息前，我们会通过业务协议、页面提示的方式向您详细说明信息收集的目的、方式、范围并征求您的明确同意。若您不同意提供前述信息，您可能无法使用该项服务，但不影响您使用其他服务。</div>
            <div className='textP'>4、我们如何委托处理、共享、转让、公开披露您的个人信息</div>
            <div className='textP'>（1）委托处理</div>
            <div className='textP'>本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</div>
            <div className='textP'>（2）共享</div>
            <div className='textP'>我们不会与我们以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：a) 与授权合作伙伴共享：我们可能会向关联公司、合作伙伴等第三方共享您的个人信息，以提供更好的客户服务和用户体验；但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。该等第三方无权将共享的个人信息用于任何其他用途。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的协议、本隐私政策要求的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护个人敏感数据。我们将按照法律法规及国家标准的要求以点击确认协议、具体场景下的点击确认动作等形式征求您的同意。b)我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</div>
            <div className='textP'>（3）转让</div>
            <div className='textP'>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：a)在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；b)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</div>
            <div className='textP'>（4）公开披露</div>
            <div className='textP'>我们仅会在以下情形下，公开披露您的个人信息：a) 获得您明确同意后；b) 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</div>
            <div className='textP'>（5）在以下情形中，收集、使用个人信息无需事先征得您的授权同意：a）与国家安全、国防安全直接相关的；b）与公共安全、公共卫生、重大公共利益直接相关的；c）与犯罪侦查、起诉、审判和判决执行等直接相关的；d）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；e）所收集的您的个人信息是您自行向社会公众公开的；f）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；g）根据您的要求签订或履行合同所必需的；h）用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；i）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；j）法律法规规定的其他情形。</div>
            <div className='textP'><div className='black'>三、我们如何存储和保护您的个人信息</div></div>
            <div className='textP'>1、个人信息存储地点</div>
            <div className='textP'>我们依照法律法规的规定，将在中华人民共和国境内运营中收集和产生的个人信息和重要数据存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果因业务需要，确需向境外提供的，我们将遵循相关国家规定或者征求您的同意。</div>
            <div className='textP'>2、个人信息存储期限</div>
            <div className='textP'>我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非法律法规另有规定或者您另行授权同意的除外。例如，对于包含个人信息的相关网络日志信息，我们会为您保存六个月；对包含个人信息的交易信息我们会为您保存三年。超出期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</div>
            <div className='textP'>3、我们如何保护您的个人信息</div>
            <div className='textP'>（1）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</div>
            <div className='textP'>（2）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</div>
            <div className='textP'>（3）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</div>
            <div className='textP'>（4）当健康前哨APP停止运营其产品或服务时，我们会：a）及时停止继续收集个人信息；b）将停止运营的通知以逐一送达或公告的形式通知您；c）对所持有的个人信息进行删除或匿名化处理。</div>
            <div className='textP'>（5）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</div>

            <div className='textP'><div className='black'>四、您的权利</div></div>
            <div className='textP'>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</div>
            <div className='textP'>1、访问、变更您的个人信息</div>
            <div className='textP'>（1）您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：健康前哨APP-我的（个人中心）-编辑资料。</div>
            <div className='textP'>（2）如果您无法通过上述路径访问这些个人信息，您可以通过健康前哨APP客户服务热线随时与我们联系。</div>
            <div className='textP'>（3）对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，您可以通过健康前哨APP客服服务热线与我们联系。</div>
            <div className='textP'>2、更正您的个人信息</div>
            <div className='textP'>（1）当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正，经对您的身份进行验证后，您可以通过“1、访问、变更您的个人信息”中罗列的方式提出更正申请。</div>
            <div className='textP'>（2）如果您无法通过上述路径更正这些个人信息，您可以通过健康前哨APP的客户服务热线与我们联系。</div>
            <div className='textP'>3、删除您的个人信息</div>
            <div className='textP'>（1）在以下情形中，您可以向我们提出删除个人信息的请求，您可以通过健康前哨APP的客户服务热线与我们联系：a）如果我们处理个人信息的行为违反法律法规；b）如果我们收集、使用您的个人信息，却未征得您的同意；c）如果我们处理个人信息的行为违反了与您的约定；d）如果您不再使用我们的产品或服务，或您注销了账号。e）如果我们不再为您提供产品或服务。</div>
            <div className='textP'>（2）若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</div>
            <div className='textP'>（3）当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</div>
            <div className='textP'>4、改变您授权同意的范围</div>
            <div className='textP'>（1）每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意，您可以通过手机系统的隐私设置改变您授权同意的范围。</div>
            <div className='textP'>（2）当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</div>
            <div className='textP'>5、个人信息主体注销账户</div>
            <div className='textP'>您随时可注销此前注册的账户，您可以通过联系客服注销账户。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</div>
            <div className='textP'>6、个人信息主体获取个人信息副本</div>
            <div className='textP'>您有权获取您的个人信息副本，您可以通过本隐私政策第七条提供的联系方式与我们联系。</div>
            <div className='textP'>7、响应您的上述请求</div>
            <div className='textP'>（1）为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在十五天内做出答复。如您不满意，还可以向监管部门进行投诉。</div>
            <div className='textP'>（2）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</div>
            <div className='textP'>（3）在以下情形中，我们将无法响应您的请求：a）与个人信息控制者履行法律法规规定的义务相关的；b）与国家安全、国防安全直接相关的；c）与公共安全、公共卫生、重大公共利益直接相关的；d）与犯罪侦查、起诉、审判和执行判决等直接相关的；e）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；f）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；g）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；h）涉及商业秘密的。</div>

            <div className='textP'><div className='black'>五、我们如何处理未成年人的个人信息</div></div>
            <div className='textP'>1、我们非常重视对未成年人个人信息的保护。我们的产品和服务面向成年人。不管是否得到父母或监护人的同意，未成年人都不应创建自己的个人信息主体账户。如果我们发现自己收集了未成年人的个人信息，则会设法尽快删除相关数据。</div>
            <div className='textP'>2、尽管当地法律和习俗对未成年人的定义不同，但我们将不满18周岁的任何人均视为未成年人。</div>

            <div className='textP'><div className='black'>六、本隐私政策如何更新</div></div>
            <div className='textP'>1、我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本隐私政策所做的任何变更。当隐私政策发生修订或重大变更时，我们会在你登录及版本更新时以弹窗等形式向您展示变更后的内容。只有在您确认修订后的隐私政策后，我们才会按照修订后的隐私政策收集、使用、处理和存储您的个人信息；您可以选择不同意修订后的隐私政策，但可能导致您无法使用健康前哨APP的产品及服务功能。</div>
            <div className='textP'>2、本隐私政策所指的重大变更包括但不限于：（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；（3）个人信息共享、转让或公开披露的主要对象发生变化；（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；（6）个人信息安全影响评估报告表明存在高风险时。</div>
            <div className='textP'>3、我们还会将本隐私政策的旧版本存档，供您查阅。</div>

            <div className='textP'><div className='black'>七、如何联系我们</div></div>
            <div className='textP'>1、如果您对本隐私政策有任何疑问、意见或建议，通过我们的客户服务热线与我们联系：0371-55018786。</div>
            <div className='textP'>2、如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向监管部门进行投诉或举报。</div>
            <div className='textP'>3、您和我们就本隐私政策内容或其执行发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，双方同意应将争议提交至河南省郑州航空港经济综合实验区有管辖权的人民法院诉讼解决。</div>

            <div className='textP'><div className='black'>八、关键词定义</div></div>
            <div className='textP'>1、“个人信息”：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。本定义出自于《中华人民共和国个人信息保护法》，以下为个人信息示例（非健康前哨APP所收集的个人信息，仅作示例说明）</div>
            <div className='textP'>个人信息举例如下：个人基本信息：个人姓名、生日、性别、民族、国籍、家庭关系、地址、个人电话号码、电子邮箱等；个人身份信息：身份证、军官证、护照、驾驶证、工作证、出入证、社保卡、居住证等；个人生物识别信息：个人基因、指纹、声纹、掌纹、耳廓、虹膜、面部识别特征等；网络身份标识信息：个人信息主体账号、IP地址、个人数字证书等；个人健康生理信息：个人因生病医治等产生的相关记录，如病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史等，以及与个人身体健康状况相关的信息，如体重、身高、肺活量等；个人教育工作信息：个人职业、职位、工作单位、学历、学位、教育经历、工作经历、培训记录、成绩单等；个人财产信息：银行账户、鉴别信息(口令)、存款信息（包括资金数量、支付收款记录等）、房产信息、信贷记录、征信信息、交易和消费记录、流水记录等，以及虚拟货币、虚拟交易、游戏类兑换码等虚拟财产信息；个人通信信息：通信记录和内容、短信、彩信、电子邮件，以及描述个人通信的数据（通常称为元数据）等；联系人信息：通讯录、好友列表、群列表、电子邮件地址列表等；个人上网记录：指通过日志储存的个人信息主体操作记录，包括网站浏览记录、软件使用记录、点击记录、收藏列表等；个人常用设备信息：指包括硬件序列号、设备 MAC 地址、软件列表、唯一设备识别码（如IMEI/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息等）等在内的描述个人常用设备基本情况的信息；个人位置信息：包括行踪轨迹、精准定位信息、住宿信息、经纬度等；其他信息：婚史、宗教信仰、性取向、未公开的违法犯罪记录等。</div>
            <div className='textP'>2、“个人敏感信息”：是指是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。。本定义出自于《中华人民共和国个人信息保护法》，以下为个人敏感信息示例（非健康前哨APP所收集的个人信息，仅作示例说明）个人敏感信息举例如下：个人财产信息：银行账户、鉴别信息(口令)、存款信息（包括资金数量、支付收款记录等）、房产信息、信贷记录、征信信息、交易和消费记录、流水记录等，以及虚拟货币、虚拟交易、游戏类兑换码等虚拟财产信息；个人健康生理信息：个人因生病医治等产生的相关记录，如病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史等；个人生物识别信息：个人基因、指纹、声纹、掌纹、耳廓、虹膜、面部识别特征等；个人身份信息：身份证、军官证、护照、驾驶证、工作证、社保卡、居住证等；其他信息: 性取向、婚史、宗教信仰、未公开的违法犯罪记录、通信记录和内容、通讯录、好友列表、群组列表、行踪轨迹、网页浏览记录、住宿信息、精准定位信息等。</div>

            <div className='textP'><div className='black'>九、收集个人信息清单</div></div>
            <div className='textP'>
                <div className='black'>注册信息</div>
                <div>在您使用本App产品及/或服务时，您可能需要向本App提供手机号码、性别、身高、体重、生日、检测记录、样品信息、操作记录、照片等与您使用本App产品及/或服务相关的信息，以便创建账户信息和受检者信息，并帮助您完成相关检测记录和管理。如果您拒绝提供相关信息，本App可能无法向您提供相关完整的服务和功能。</div>
            </div>

            <div className='textP'>
                <div className='black'>传感器</div>
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>使用目的：</span>经您授权，我们会收集您的加速度传感器和光照传感器信息，以便为您提供试纸识别功能
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>信息说明：</span>我们仅在您使用对应功能时收集相应信息，例如您在使用相机进行试纸图像拍摄时，使用加速度传感器用于感知您设备横竖屏切换的状态以便调整图像旋转角度，或者在光照亮度不足时，使用光照传感器识别环境亮度，以便调整图像明暗度。
            </div>

            <div className='textP'>
                <div className='black'>相机</div>
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>使用目的：</span>经您授权，我们会收集您的相机信息，以便为您提供试纸检测功能和更换用户头像功能
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>信息说明：</span>我们仅在您使用对应功能时收集相应信息，例如您在进行试纸颜色检测功能时，或者更换用户头像功能时。不同的系统显示的名称可能有所差异，如相机、摄像头等。您可以自行选择开启或者关闭相机的授权，一旦关闭您将无法使用拍照上传头像功能，但不影响您使用查询个人信息等基础服务。
            </div>

            <div className='textP'>
                <div className='black'>相册</div>
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>使用目的：</span>经您授权，我们会收集您的相册信息，以便为您上传和保存照片、头像展示功能
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>信息说明：</span>我们仅在您使用对应功能时收集相应信息，例如您在使用更换用户头像功能时。不同的系统显示的名称可能有所差异，如相册、存储权限等。您可以自行选择开启或者关闭相册的授权，一旦关闭您将可能无法更换头像、更新App功能，但不影响您使用检测记录，查看个人信息等基础服务
            </div>

            <div className='textP'>
                <div className='black'>电话权限</div>
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>使用目的：</span>经您授权，我们会收集您的电话信息，以便为您拨打客服电话功能
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>信息说明：</span>我们仅在您使用对应功能时收集相应信息，例如您在联系客服时。您可以自行选择开启或者关闭电话的授权，一旦关闭您将可能无法拨打客服电话功能，但不影响您使用检测记录等基础服务
            </div>

            <div className='textP'>
                <div className='black'>设备信息</div>
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>使用目的：</span>您在访问或者使用我们服务的过程中，我们会收集您的设备信息，以便获取屏幕分辨率等信息进行界面展示、避免其他设备的异常登录、留存必要的日志信息，从而保障您的账号安全和系统运行安全
            </div>
            <div className='textP'>
            <span style={{fontWeight: "bold"}}>信息说明：</span>我们收集的设备状态包括您的设备型号，IMEI/android ID/IDFA/OPEN UDID/GUID/OAID、SIM卡IMSI、ICCID信息等设备标识符、设备MAC地址、移动应用列表、电信运营商等。未经您的授权，我们不会提前获取以上信息。目前多数手机终端厂商支持对设备标识符的更改，以保障您对个人信息的自助控制，具体撤回或更改的方式可参见您所使用的终端设备
            </div>

            <div className='textP'><div className='black'>十、第三方SDK列表</div></div>
            <div className='textP'>我们会对SDK或其他类似的应用程序进行严格的安全检测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方 SDK ，并及时在本说明中向您公开说明接入第三方 SDK 的最新情况。请注意，第三方 SDK 可能因为版本升级、策略调整等原因导致数据类型存在一些变化，请以其公示的官方说明为准。目前本应用接入的第三方 SDK 如下：</div>
            <div className='textP'>第三方SDK名称：微信SDK </div>
            <div className='textP'>收集个人信息目的：登录和分享</div>
            <div className='textP'>收集个人数据类型：用户的昵称、头像</div>
            <div className='textP'>第三方SDK隐私声明或者开发指南：https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</div>
            
            <div className="row_space_small"/>
        </>
    )
})

const UserAgreementPage = forwardRef((props = {}, ref) => {
    const history = useHistory()

    const backOnClickHd = () => {
        history.goBack()
    }

    return (
        <>
            <BackupTitle backOnClickHd={backOnClickHd} noShare={true}/>
            <div className='row_center'>
                <h2>健康前哨APP用户协议</h2>
            </div>
            
            <div className='textP'><div className='black'>一、我们的声明</div></div>
            <div className='textP'>1、本协议是您与郑州方欣生物科技有限责任公司（下称“我们”）之间关于使用健康前哨APP的服务所订立的协议。为确保您能正常地使用我们的服务，您应当阅读并遵守《健康前哨APP用户协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及使用某项服务的单独协议，如您点击勾选即视为您同意并接受协议条款内容。本服务面向成年人，如您是未满18周岁的未成年人，将无权使用我们提供的服务。</div>
            <div className='textP'>2、您在进行注册程序过程中，当您点选“同意”按钮时即视为您已仔细阅读本协议，同意接受本协议项下的所有条款，包括接受我们对本协议条款随时所做的任何修改，并愿意受其约束。</div>
            <div className='textP'>3、除非您已阅读并接受本协议所有条款，否则您无权使用我们的服务。您同意接受更新后的本协议条款；如您不同意本协议的更新或修订，请您立即停止使用我们的任何服务。当您与我们发生争议时，应以最新的服务协议为准。</div>
            <div className='textP'>4、我们在此特别提醒您，在您使用注册前请确认您已确实仔细阅读了本协议，如果您对本协议的任何条款或者将来随时可能修改、补充的条款有异议，您可选择不注册成为我们的用户或不再继续使用我们的任何服务。</div>
            <div className='textP'>5、本协议的条款适用于我们提供的各种服务，但当您使用我们某一特定服务时，如该服务另有单独的服务条款、指引或规则，您应遵守本协议及我们不时公布的与该服务相关的服务条款、指引或规则等。前述所有的指引和规则，均构成本协议的一部分。除非本协议另有其他明示规定，新推出的产品或服务、增加或强化目前本服务的任何新功能，均受到本协议之规范。</div>

            <div className='textP'><div className='black'>二、我们的服务</div></div>
            <div className='textP'>1、我们的服务自注册或登录健康前哨APP即开始向您提供，并且您可以通过健康前哨APP获得相应的服务。在我们的服务过程中，有可能涉及第三方向您提供服务（以下简称“第三方服务"）。您在使用这些第三方服务时，您在遵守本协议的同时，还需要优先遵守这些第三方服务的相关规则，这些规则会在您首次使用相关服务的时候向您展示，请您留意阅读。第三方服务将由该服务的实际提供方向您承担相应的责任，我们会给予您必要的协助，并在法律要求的必要范围内承担相应的责任。</div>
            <div className='textP'>2、为使用本服务，您必须能够自行通过有法律规定的相关资质的第三方对您提供互联网接入服务，并自行承担以下内容：（1）与服务有关的通信设备（包括但不限于电脑终端、手机终端、调制解调器及其他与接入互联网有关的装置）；（2）通信服务所需的费用（包括但不限于为接入互联网而支付的电话费及宽带费）；3、我们有权根据情况变化调整服务的具体内容，本网站服务内容进行调整的，我们会对前述变更进行通知或公告，或在一定期限内，当您使用相应服务前予以提示。如用户不同意上述调整，您将无法继续使用该服务；如用户继续使用服务，视为用户同意调整后的内容并同意遵守。</div>

            <div className='textP'><div className='black'>三、服务暂停、变更与中止条款</div></div>
            <div className='textP'>1、鉴于我们服务的特殊性，我们有权随时变更、中断或终止部分或全部的服务。如变更、中断或终止的服务属于免费服务，我们无需通知您，也无需对任何您或任何第三方承担任何责任。如变更、中断或终止的服务属于付费服务，我们会事先通知您，并征得您的同意。</div>
            <div className='textP'>2、您理解，我们需要定期或不定期地对提供本服务的平台或相关的设备进行检修或者维护，如因此类情况而造成本服务在合理时间内的中断，我们无需为此承担任何责任，但我们应尽可能事先进行通告。</div>
            <div className='textP'>3、如发生下列任何一种情形，我们有权随时中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担任何责任：（1）您违反国家有关法律法规或我们的管理规定，侵害他人合法权益的；（2）您丧失使用网站服务的行为能力；（3）您违反我们发布的政策；（4）我们认为需要终止服务的情况。</div>
            <div className='textP'>4、服务发生变更、中断、终止后，我们仍有以下权利：（1）服务发生终止后，我们将您的注册数据及以前的行为记录进行匿名化处理；（2）如您在服务变更、中断、终止前，在我们平台上存在违法行为或违反条款的行为，我们仍可行使本服务条款所规定的权利。</div>
            <div className='textP'>5、因不可抗力、网络状况、通讯线路、用户自身过错等技术原因，或其他不可控原因导致您不能正常使用我们的服务，我们不承担相应责任。</div>

            <div className='textP'><div className='black'>四、商品交易服务规则</div></div>
            <div className='textP'>1、用户可以使用我们提供的商品交易服务。我们的某些服务可能会以收费方式提供，用户使用我们的收费服务时，应当及时、足额支付相应的费用。只有相关款项被及时、足额地支付之后，您才能获得相应的服务。</div>
            <div className='textP'>2、用户订购商品时，应当仔细确认所购商品的名称、价格、数量、型号、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人/用户的行为和意思表示视为用户/收货人的行为和意思表示，用户/收货人应对收货人/用户的行为及意思表示的法律后果承担连带责任。</div>
            <div className='textP'>3、如果出现降价或促销，除另有说明外，我们不提供价格保护或退款。由于软件类商品或服务含授权/激活信息（包括且不限于邀请码、密码等），为特殊商品，在交易确立完成后，不适用无理由退货，如无质量问题不予退换货。如果您需要任何咨询或帮助，您可随时与我们取得联系。</div>

            <div className='textP'><div className='black'>五、用户账号管理</div></div>
            <div className='textP'>1、您可以直接通过健康前哨APP注册您的账户，您承诺在注册您的账户时提供真实的信息，并愿意承担由于提供虚假信息而对您造成的不利后果以及对我们或第三方造成的任何损失。在您申请开通某些服务时，我们会对您的真实身份进行核实，您承诺将积极地予以配合，否则您将无法使用这些服务。</div>
            <div className='textP'>2、您一旦注册成功，成为我们的合法用户，将得到一个您的账号和/或密码。您的账号和/或密码由您负责保管。您应当对任何以您账号进行的所有活动和事件负全责。若发现任何非法使用您的账号或存在安全漏洞的情况，请立即通知我们。</div>
            <div className='textP'>3、为便于您使用我们的服务和我们与第三方合作向您提供的服务，在征得您的同意后，我们会将您在我们注册的账户与您在我们的相关合作方的平台注册的账户进行关联。我们将根据法律法规的要求，履行其作为移动互联网信息服务提供者应当履行的义务。</div>
            <div className='textP'>4、我们特别提醒您应采取特定措施保护您的账户的安全，包括但不限于妥善保管账户密码、安装防病毒木马软件、定期更改密码、使用后安全退出等。如您账户和密码因黑客行为或您的保管疏忽等情况被盗用，除非您能证明该事件由于我们的故意或重大过失直接导致，否则您应承担被盗用期间产生的一切责任和后果。</div>
            <div className='textP'>5、您的账户只限于您本人使用，请勿与他人共用您的账户，否则，我们将无法保证您的数据安全。您了解并同意，使用您的账户实施的任何行为都视为您的行为，即使是他人使用您的账户实施的行为，您也将承担连带责任。如果您发现有人未经授权使用了您的账户，请立即联系并通知我们。</div>

            <div className='textP'><div className='black'>六、用户的权利和义务</div></div>
            <div className='textP'>1、用户使用本协议项下服务，应当遵守《中华人民共和国网络安全法》《中华人民共和国电信条例》《中华人民共和国计算机信息网络国际联网暂行规定》和其他有关法律、法规或相关规定、以及本协议的约定，不得存在任何违法违规行为，不得侵犯任何第三方的合法权益。</div>
            <div className='textP'>2、用户账号的所有权归我们所有，用户完成申请注册手续后，获得用户账号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。因经营需要，我们有权回收用户账号。</div>
            <div className='textP'>3、用户有权更改、删除所注册账号的个人资料、注册信息及传送内容等，但需注意，删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户需承担该风险。</div>
            <div className='textP'>4、用户有责任妥善保管注册账号信息及账号密码的安全，用户需要对注册账号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他成员的账号或密码。在您怀疑他人在使用您的账号或密码时，您同意立即通过客户服务热线通知我们。</div>
            <div className='textP'>5、您发现其他用户有违法或违反我们管理规定的行为，可以通过客户服务热线向我们进行反映要求处理。您因我们展示的内容与其他用户发生纠纷的，司法部门可以要求我们根据法律程序提供该案件所需证据材料。</div>
            <div className='textP'>6、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，我们有权依据协议终止对违约用户的账号提供服务。同时，我们保留在任何时候收回用户账号、用户名的权利。</div>
            <div className='textP'>7、用户注册账号后如果长期（超过一年）不登录该账号，我们有权回收该账号，以免造成资源浪费，由此带来问题均由用户自行承担。</div>

            <div className='textP'><div className='black'>七、使用规则</div></div>
            <div className='textP'>1、用户充分了解并同意，用户必须为自己注册账号下的一切行为负责，包括您所传送的任何内容以及由此产生的任何结果。用户应对我们服务的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。我们无法且不会对因用户行为而导致的任何损失或损害承担责任。</div>
            <div className='textP'>2、用户在健康前哨APP所传送的任何内容并不反映我们的观点或政策，我们对此不承担任何责任。</div>
            <div className='textP'>3、用户充分了解并同意，用户须对在健康前哨APP上的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义传播任何信息；不得恶意使用注册账号导致其他用户误认；否则我们有权立即停止提供服务，收回用户账号并由用户独自承担由此而产生的一切法律责任。</div>
            <div className='textP'>4、我们提供的服务中可能包括广告，用户同意在使用过程中显示我们和第三方供应商、合作伙伴提供的广告。</div>
            <div className='textP'>5、用户不得利用我们的服务制作、上载、复制、发送如下内容：（1）反对宪法所确定的基本原则的；（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；（3）损害国家荣誉和利益的；（4）煽动民族仇恨、民族歧视，破坏民族团结的；（5）破坏国家宗教政策，宣扬邪教和封建迷信的；（6）散布谣言，扰乱社会秩序，破坏社会稳定的；（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；（8）侮辱或者诽谤他人，侵害他人合法权益的；（9）含有法律、行政法规禁止的其他内容的信息。</div>
            <div className='textP'>6、我们可依其合理判断，对违反有关法律法规或本协议约定；或侵犯、妨害、威胁任何人权利或安全的内容，或者假冒他人的行为，我们有权依法停止传输任何前述内容，并有权依其自行判断对违反本条款的任何人士采取适当的法律行动，包括但不限于，删除具有违法性、侵权性、不当性等内容，终止违反者的成员资格，阻止其使用全部或部分服务，并且依据法律法规保存有关信息并向有关部门报告等。</div>
            
            <div className='textP'><div className='black'>八、隐私保护</div></div>
            <div className='textP'>1、保护您隐私是我们的一项基本政策，我们保证不对外公开或向第三方提供您的注册资料及您在使用本服务时存储的非公开内容，但下列情况除外：（1）事先获得您的明确授权；（2）根据有关的法律法规要求；（3）按照相关政府主管部门的要求；（4）为维护社会公众的利益；（5）为维护我们的合法权益。</div>
            <div className='textP'>2、您使用或继续使用我们的服务，即意味着同意我们按照《健康前哨APP隐私保护政策》收集、使用、储存和分享您的相关信息。详情请参见《健康前哨APP隐私保护政策》。</div>
            
            <div className='textP'><div className='black'>九、法律责任及免责</div></div>
            <div className='textP'>1、用户违反本协议或相关的服务协议的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿我们与合作公司、关联公司，并使之免受损害。</div>
            <div className='textP'>2、用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，我们及合作单位不承担责任。</div>
            <div className='textP'>3、本服务协议构成您与我们对服务之约定事项及其他有关事宜的完整协议，除服务条款规定的之外，未赋予服务条款各方其他权利，例如版权、商标权、和其它知识产权和所有权的权利。</div>
            <div className='textP'>4、在任何情况下，我们均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用我们的服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用我们的服务而支付给我们的费用（如有） 。</div>
            <div className='textP'>5、应用开启提醒功能，将默认开启音频后台模式，这么做会大幅降低电池续航能力。</div>
            <div className='textP'>6、健康前哨APP提供的各类检测功能所生成的结果仅供参考，这些结果不应被视为专业医疗诊断、建议或治疗的替代品，不能作为诊断和治疗的直接依据。用户不应过度依赖这些结果，我们及合作单位对因用户过度依赖或误解检测结果而导致的任何损失或损害不承担责任。</div>

            <div className='textP'><div className='black'>十、违约赔偿</div></div>
            <div className='textP'>您同意保障和维护我们及其他用户的利益，如因您违反有关法律、法规或我们的管理规定而给我们或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。</div>

            <div className='textP'><div className='black'>十一、服务条款修改</div></div>
            <div className='textP'>1、我们有权根据服务情况变更、终止管理规定的各项条款</div>
            <div className='textP'>2、如果您不同意我们的管理规定所做的修改，我们有权停止服务。如果您继续使用该服务，则视为您接受我们对服务协议相关条款所做的修改。</div>
        </>
    )
})



// -----------------------------------------------------------------------
export { AboutPage, CompanyPage, PrivacyAgreementPage, UserAgreementPage }

